export default __webpack_public_path__ + "static/media/IMG4.f0329fa2.jpg";